import React, { ReactNode } from 'react';
type SectionHeadingProps = {
  eyebrow?: string;
  title: ReactNode;
  lede?: ReactNode;
  tone?: 'dark' | 'light';
};
export function SectionHeading({
  eyebrow,
  title,
  lede,
  tone = 'light'
}: SectionHeadingProps) {
  const dark = tone === 'dark';
  return <div className="mx-auto max-w-3xl text-center" data-id="element-86" data-mp="3k06y7yjxd00d">
      {eyebrow && <p className={`text-xs font-bold uppercase tracking-[0.16em] sm:text-sm ${dark ? 'text-electric' : 'text-[#1474D4]'}`} data-id="element-87" data-mp="3k29kc7hyi8zt">
          {eyebrow}
        </p>}
      <h2 className={`text-balance mt-3 font-display text-[30px] font-black leading-[1.08] tracking-tight sm:text-5xl ${dark ? 'text-white' : 'text-navy'}`} data-id="element-88" data-mp="gi55q2n4aqi8">
        {title}
      </h2>
      {lede && <p className={`mt-4 text-base leading-relaxed sm:text-lg ${dark ? 'text-white/75' : 'text-navy/70'}`} data-id="element-89" data-mp="6raiow21rmvq">{lede}</p>}
    </div>;
}